import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'sonner';
import { LandingCarrusel } from '@/components/LandingCarrusel';
import { LandingMenu } from '@/components/LandingMenu';
import { LandingTestimonios } from '@/components/LandingTestimonios';

const API = process.env.REACT_APP_BACKEND_URL;
const WA = '50254307807';
const AZUL = '#1FA3E8';
const IMG = {
  heroMadera: 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/6409f7a14dce1bc8a567039caf207cd149e0eafcc676a6e92095a1b5ceb1cbc0.jpeg',
  oficinaInox: 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/83602ceda19520939390801336b3f50d9bc6c12bca6c41e3a35181ec94e9a425.jpeg',
  soldador: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/um3w2yw3_25e61597-60d3-4883-b427-e678e3d9c3a9.jpeg',
  obraPuerta: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/6ruge6sy_d68881ad-a39f-4df0-bb94-e4fca80e9110.jpeg',
  obraVentana: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/fxfb1yd0_9e2746b7-65b4-4c62-a85f-6717745b9747.jpeg',
};

const COLORES = [
  ['Gris', 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/8f45681c3d7b03ed221a6274b77676349d08e06304494ccfc342ff690b307695.jpeg'],
  ['Negro', 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/17a1c64777c31e4a14d30d809d6d871eb04a769cae4aaef000010e1ed27dbc80.jpeg'],
  ['Blanco', 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/a70bb8d39d2544d5bb6cb18343a87cd9a783a6d756059ef4626d779a0e5197ce.jpeg'],
  ['Bronce', 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/00db1f9599b40f138af777e58f5035a63a2ae56662061d48abfa07511c360ade.jpeg'],
  ['Inox', 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/3641621e8c6e26bfca79d7bceebbf81e0fc5c3eb1a576b2916dd335bafd09b52.jpeg'],
  ['Imitación Madera', 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/236f029bb6537390d24709c16f10326275e3a4cf337b38a5537692e3fe1ffb1f.jpeg'],
];

const DEPARTAMENTOS = ['Guatemala', 'Sacatepéquez', 'Chimaltenango', 'Escuintla', 'Santa Rosa', 'Sololá', 'Totonicapán', 'Quetzaltenango', 'Suchitepéquez', 'Retalhuleu', 'San Marcos', 'Huehuetenango', 'Quiché', 'Baja Verapaz', 'Alta Verapaz', 'Petén', 'Izabal', 'Zacapa', 'Chiquimula', 'Jalapa', 'Jutiapa', 'El Progreso'];

const waLink = (text) => `https://wa.me/${WA}?text=${encodeURIComponent(text)}`;

export default function LandingEuro() {
  const [form, setForm] = useState({ nombre: '', telefono: '', departamento: '', detalles: '' });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    axios.post(`${API}/api/landing/track`, { producto: 'ventanas_puertas_euro' }).catch(() => {});
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim() || !form.telefono.trim() || !form.departamento) {
      toast.error('Completa tu nombre, teléfono y departamento');
      return;
    }
    try {
      setSending(true);
      const res = await axios.post(`${API}/api/landing/euro/lead`, form);
      setDone(res.data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Error enviando, intenta de nuevo');
    } finally { setSending(false); }
  };

  return (
    <div style={{ fontFamily: "'Inter', system-ui, sans-serif" }} className="min-h-screen bg-[#080B10] text-white">
      <Toaster position="top-center" richColors />

      {/* Top bar */}
      <header className="sticky top-0 z-40 bg-[#080B10]/90 backdrop-blur border-b border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <div>
            <p className="font-black tracking-tight text-lg leading-none">SOLUCIONES <span style={{ color: AZUL }}>ARQUITECTÓNICAS</span></p>
            <p className="text-[10px] text-white/50 tracking-[0.25em] uppercase">Grupo SACH · Guatemala</p>
          </div>
          <div className="flex items-center gap-2">
            <LandingMenu actual="/ventanasypuertaseuro" />
            <a href={waLink('¡Hola! Vi la página de ventanas y puertas Línea Euro y quiero una cotización 😊')}
              target="_blank" rel="noreferrer" data-testid="wa-header-btn"
              className="bg-[#25D366] hover:brightness-110 text-white text-sm font-bold px-4 py-2 rounded-full transition-all">
              WhatsApp
            </a>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="relative">
        <img src={IMG.heroMadera} alt="Puertas de aluminio Línea Euro" className="w-full h-[68vh] object-cover object-center opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#080B10] via-[#080B10]/50 to-[#080B10]/30" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-6xl mx-auto px-4 pb-10 w-full">
            <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">Fabricación e instalación profesional</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] max-w-3xl">
              Ventanas y Puertas <span style={{ color: AZUL }}>Línea Euro</span>
            </h1>
            <p className="text-white/70 text-base mt-4 max-w-xl">
              Moderniza tus espacios con la elegancia del aluminio Línea Euro. Diseño, resistencia y funcionalidad para darle a tu hogar o negocio una imagen moderna y sofisticada.
            </p>
            <div className="flex gap-3 mt-6 flex-wrap">
              <a href="#cotizar" data-testid="hero-cta"
                style={{ background: AZUL }}
                className="hover:brightness-110 text-white font-black px-6 py-3 rounded-full text-sm transition-all">
                COTIZA GRATIS →
              </a>
              <a href={waLink('¡Hola! Quiero cotizar ventanas o puertas Línea Euro 😊')} target="_blank" rel="noreferrer"
                className="border border-white/25 hover:border-white/60 text-white font-bold px-6 py-3 rounded-full text-sm transition-colors">
                Escríbenos por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Banner 18 años */}
      <section style={{ background: AZUL }} className="text-white" data-testid="banner-experiencia">
        <div className="max-w-6xl mx-auto px-4 py-8 flex flex-col sm:flex-row items-center gap-6">
          <p className="text-6xl sm:text-7xl font-black leading-none shrink-0">+18</p>
          <div>
            <p className="font-black text-xl sm:text-2xl leading-tight">AÑOS DE EXPERIENCIA</p>
            <p className="text-white/90 text-sm sm:text-base mt-1 font-medium">
              Confía tus proyectos en manos profesionales. Miles de mt² de ventanas y puertas instalados en Guatemala, El Salvador, Honduras y Costa Rica.
            </p>
          </div>
        </div>
      </section>

      {/* Sección 1: texto + imagen */}
      <section className="max-w-6xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">Elegancia europea</p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight">Moderniza tus espacios con la <span style={{ color: AZUL }}>Línea Euro</span></h2>
          <p className="text-white/60 text-base mt-4">
            Las puertas, ventanas y fachadas de aluminio Línea Euro combinan diseño, resistencia y funcionalidad
            para darle a tu hogar o negocio una imagen moderna y sofisticada.
          </p>
          <ul className="mt-5 space-y-2 text-sm text-white/75">
            <li className="flex items-start gap-2"><span style={{ color: AZUL }} className="font-black">◆</span> Diseño moderno</li>
            <li className="flex items-start gap-2"><span style={{ color: AZUL }} className="font-black">◆</span> Alta durabilidad y resistencia</li>
            <li className="flex items-start gap-2"><span style={{ color: AZUL }} className="font-black">◆</span> Excelente acabado</li>
            <li className="flex items-start gap-2"><span style={{ color: AZUL }} className="font-black">◆</span> Fabricación e instalación profesional a la medida de tu proyecto</li>
          </ul>
        </div>
        <figure className="rounded-3xl overflow-hidden border border-white/10">
          <img src={IMG.oficinaInox} alt="Puertas de aluminio Línea Euro en oficina" className="w-full h-[420px] object-cover object-center" />
        </figure>
      </section>

      {/* Colores disponibles */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-colores">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Personaliza tu proyecto</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-3">Colores <span style={{ color: AZUL }}>disponibles</span></h2>
        <p className="text-white/50 text-sm text-center mb-8 max-w-xl mx-auto">
          El precio varía dependiendo del diseño, el color del material y el lugar de instalación. Cotiza gratis y te asesoramos.
        </p>
        <p className="text-center text-sm mb-8 -mt-4 max-w-xl mx-auto border border-[#1FA3E8]/40 bg-[#1FA3E8]/10 rounded-2xl px-4 py-3 text-white/75" data-testid="euro-termoacustico">
          ⭐ <span className="font-bold text-white">Vidrio insulado termoacústico disponible:</span> doble vidrio con cámara sellada para el máximo aislamiento contra calor y ruido.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {COLORES.map(([nombre, src]) => (
            <figure key={nombre} className="rounded-2xl overflow-hidden border border-white/10 group" data-testid={`color-${nombre.toLowerCase().replace(/ /g, '-')}`}>
              <img src={src} alt={`Aluminio Línea Euro color ${nombre}`} className="w-full h-36 object-cover group-hover:scale-105 transition-transform duration-500" />
              <figcaption className="text-xs text-white/80 text-center font-bold px-2 py-2.5 bg-white/[0.05]">{nombre}</figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* Sección 2: imagen + texto */}
      <section className="max-w-6xl mx-auto px-4 pb-14 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <figure className="rounded-3xl overflow-hidden border border-white/10 order-1 md:order-none">
          <img src="https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/wvdfcm7d_ba5d3722-8c5f-4787-a117-e17f2778b611.jpeg" alt="Instalador profesional colocando ventana Línea Euro" className="w-full h-[420px] object-cover object-center" />
        </figure>
        <div>
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">¡Somos Profesionales!</p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight">No arriesgues tu inversión en <span style={{ color: AZUL }}>manos inexpertas</span></h2>
          <p className="text-white/60 text-base mt-4">
            Nuestro equipo de fabricantes e instaladores certificados trabaja con los más altos estándares.
            Cada proyecto es supervisado de principio a fin para garantizar un acabado impecable, hermético y seguro.
          </p>
          <p className="text-white/60 text-base mt-3">
            Por eso miles de familias y empresas en la región confían en nosotros desde hace más de 18 años.
          </p>
          <a href="#cotizar" style={{ background: AZUL }}
            className="inline-block mt-6 hover:brightness-110 text-white font-black px-6 py-3 rounded-full text-sm transition-all">
            QUIERO MI COTIZACIÓN →
          </a>
        </div>
      </section>

      {/* Trabajo real */}
      <section className="max-w-6xl mx-auto px-4 pb-14">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Nuestro equipo en acción</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Trabajo real, resultados <span style={{ color: AZUL }}>reales</span></h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-4xl mx-auto">
          <figure className="rounded-2xl overflow-hidden border border-white/10 group relative">
            <img src="https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/jblvp4cg_df99a4ad-3b9b-4517-b6f7-5d1acaac2888.jpeg" alt="Equipo instalando ventanas Línea Euro" className="w-full h-72 object-cover group-hover:scale-105 transition-transform duration-500" />
            <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/90 to-transparent text-xs text-white/90 px-3 pt-8 pb-2 font-bold">Instalación profesional de ventanas Línea Euro</figcaption>
          </figure>
          <figure className="rounded-2xl overflow-hidden border border-white/10 group relative">
            <img src={IMG.obraVentana} alt="Ventana de aluminio Línea Euro instalada" className="w-full h-72 object-cover group-hover:scale-105 transition-transform duration-500" />
            <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/90 to-transparent text-xs text-white/90 px-3 pt-8 pb-2 font-bold">Ventana Línea Euro instalada</figcaption>
          </figure>
        </div>
      </section>

      {/* Carrusel de proyectos (estilo Netflix) */}
      <section className="pb-14" data-testid="carrusel-proyectos">
        <div className="max-w-6xl mx-auto px-4">
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2">Inspírate</p>
          <h2 className="text-2xl sm:text-3xl font-black mb-6">Ideas para tu <span style={{ color: AZUL }}>proyecto</span></h2>
        </div>
        <LandingCarrusel producto="ventanas_puertas_euro" initial={[
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/tpb9mi1u_35649dee-9281-44a8-939f-756a49442286.jpeg', caption: 'Ventana abatible con vista al jardín' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/zwc8rvhi_01595b0d-f51b-421e-a07d-dae602a98870.jpeg', caption: 'Ventana doble en color blanco' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/wbrggzlv_37d6e811-b107-4177-a00b-b8649a985259.jpeg', caption: 'Ventana francesa imitación madera' },
          { url: 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts/6ruge6sy_d68881ad-a39f-4df0-bb94-e4fca80e9110.jpeg', caption: 'Puerta y fachada en color oscuro' },
          { url: 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/6409f7a14dce1bc8a567039caf207cd149e0eafcc676a6e92095a1b5ceb1cbc0.jpeg', caption: 'Puertas imitación madera para tu hogar' },
          { url: 'https://static.prod-images.emergentagent.com/jobs/f8421f9d-b7ab-4b05-852e-30567b337ae5/images/83602ceda19520939390801336b3f50d9bc6c12bca6c41e3a35181ec94e9a425.jpeg', caption: 'Puertas inox para oficinas' },
        ]} />
      </section>

      {/* Manual */}
      <section className="max-w-3xl mx-auto px-4 pb-14" data-testid="seccion-manual">
        <div className="bg-white/[0.04] border border-white/10 rounded-3xl p-6 sm:p-8 text-center">
          <p className="font-black text-lg" data-testid="guia-card">📘 Manual de Mantenimiento GRATIS</p>
          <p className="text-white/55 text-sm mt-2 max-w-xl mx-auto">
            Descarga nuestro manual con la limpieza correcta de tu ventanería Línea Euro: perfiles de aluminio, vidrios, herrajes, rieles y empaques, para que luzca y funcione como nueva por décadas.
          </p>
          <a href={`${API}/api/landing/guia-euro`} data-testid="guia-download-btn"
            className="inline-block mt-4 border border-[#1FA3E8] text-[#1FA3E8] hover:bg-[#1FA3E8] hover:text-white font-black px-6 py-2.5 rounded-full text-xs transition-colors">
            DESCARGAR PDF
          </a>
        </div>
      </section>

      {/* Testimonios */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-testimonios">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Lo que dicen nuestros clientes</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Clientes que confiaron <span style={{ color: AZUL }}>en nosotros</span></h2>
        <LandingTestimonios producto="ventanas_puertas_euro" initial={[
            {
              nombre: 'Jorge Ramírez',
              texto: 'Cambiamos todas las ventanas de la casa por Línea Euro en color negro y la diferencia es enorme: se ven modernas, cierran perfecto y ya no entra ruido de la calle. La calidad del aluminio se nota desde que lo tocas.',
            },
            {
              nombre: 'Claudia Estrada',
              texto: 'Muy responsables en todo el proceso. Cumplieron las fechas, el equipo llegó puntual y dejaron el área limpia. Las puertas en imitación madera quedaron idénticas a lo que nos mostraron en el diseño.',
            },
            {
              nombre: 'Luis Fernando Paz',
              texto: 'Para nuestras oficinas necesitábamos algo elegante y duradero. Nos asesoraron con los colores, nos enviaron avances y el resultado superó lo esperado. Se nota la experiencia que tienen, cero complicaciones.',
            },
          ]} color={AZUL} />
      </section>

      {/* Cobertura */}
      <section className="border-y border-white/10 bg-white/[0.03]">
        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="font-black text-base sm:text-lg tracking-wide" style={{ color: AZUL }} data-testid="cobertura-paises">
            Guatemala · El Salvador · Honduras · Costa Rica
          </p>
          <p className="text-white/50 text-sm mt-1">Cobertura regional con instalación profesional</p>
        </div>
      </section>

      {/* FAQ */}
      <section className="max-w-3xl mx-auto px-4 py-14" data-testid="seccion-faq">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Resolvemos tus dudas</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Preguntas <span style={{ color: AZUL }}>frecuentes</span></h2>
        <div className="space-y-3">
          {[
            ['¿Cuánto cuestan las ventanas y puertas Línea Euro?',
              'Cada proyecto es único: el precio varía dependiendo del diseño, el color del material y el lugar de instalación. Por eso la cotización es GRATIS y sin compromiso — envíanos las medidas o fotos por WhatsApp y te respondemos el mismo día.'],
            ['¿Qué colores están disponibles?',
              'Tenemos 6 acabados: gris, negro, blanco, bronce, inox e imitación madera. Te asesoramos para elegir el que mejor combine con tu espacio.'],
            ['¿Por qué elegir aluminio Línea Euro?',
              'Es un sistema de perfiles europeos de alta gama: diseño moderno, alta durabilidad y resistencia, excelente acabado y mejor hermeticidad que el aluminio tradicional. Ideal para hogares, oficinas y fachadas.'],
            ['¿Trabajan fuera de la ciudad capital?',
              'Sí, cubrimos toda Guatemala y también El Salvador.'],
            ['¿Cómo empiezo mi proyecto?',
              'Muy fácil: llena el formulario de esta página o escríbenos al WhatsApp 5430-7807. Te asesoramos desde el diseño hasta la instalación final.'],
          ].map(([q, a], i) => (
            <details key={q} className="group bg-white/[0.04] border border-white/10 rounded-2xl overflow-hidden" data-testid={`faq-item-${i}`}>
              <summary className="flex items-center justify-between gap-4 cursor-pointer px-5 py-4 font-bold text-sm sm:text-base list-none [&::-webkit-details-marker]:hidden hover:bg-white/[0.03] transition-colors">
                {q}
                <span style={{ color: AZUL }} className="text-xl font-black shrink-0 group-open:rotate-45 transition-transform">+</span>
              </summary>
              <p className="px-5 pb-5 text-white/65 text-sm leading-relaxed">{a}</p>
            </details>
          ))}
        </div>
      </section>

      {/* Formulario */}
      <section id="cotizar" className="max-w-2xl mx-auto px-4 pb-16">
        <div className="bg-white/[0.05] border border-white/10 rounded-3xl p-6 sm:p-8">
          {done ? (
            <div className="text-center py-6" data-testid="lead-success">
              <p className="text-5xl mb-4">✅</p>
              <h3 className="text-2xl font-black">¡Recibido, {form.nombre.split(' ')[0]}!</h3>
              <p className="text-white/60 text-sm mt-2 mb-6">Un asesor te contactará muy pronto. Si quieres respuesta inmediata, continúa por WhatsApp:</p>
              <a href={done.wa_link} target="_blank" rel="noreferrer" data-testid="lead-wa-btn"
                className="inline-block bg-[#25D366] hover:brightness-110 text-white font-black px-8 py-3 rounded-full text-sm transition-all">
                💬 Continuar en WhatsApp
              </a>
            </div>
          ) : (
            <>
              <h2 className="text-2xl font-black">Cotiza <span style={{ color: AZUL }}>GRATIS</span> en 30 segundos</h2>
              <p className="text-white/50 text-sm mt-1 mb-6">Sin compromiso. Te contactamos por WhatsApp o llamada.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Tu nombre *</label>
                  <input value={form.nombre} onChange={set('nombre')} data-testid="lead-nombre" placeholder="Ej: Carlos Pérez"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors" />
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Teléfono / WhatsApp *</label>
                  <input value={form.telefono} onChange={set('telefono')} data-testid="lead-telefono" placeholder="Ej: 5555 5555" inputMode="tel"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors" />
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">¿En qué departamento estás? *</label>
                  <select value={form.departamento} onChange={set('departamento')} data-testid="lead-departamento" style={{ colorScheme: 'dark' }}
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors">
                    <option value="">Selecciona…</option>
                    {DEPARTAMENTOS.map((d) => <option key={d} value={d}>{d}</option>)}
                  </select>
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Detalles de tu cotización</label>
                  <textarea value={form.detalles} onChange={set('detalles')} data-testid="lead-detalles" rows={3}
                    placeholder="Ej: 3 ventanas de 1.5 x 1.2 m en color negro y una puerta…"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors resize-none" />
                </div>
                <button type="submit" disabled={sending} data-testid="lead-submit"
                  style={{ background: AZUL }}
                  className="w-full hover:brightness-110 disabled:opacity-60 text-white font-black py-3.5 rounded-xl text-sm transition-all">
                  {sending ? 'Enviando…' : 'QUIERO MI COTIZACIÓN GRATIS'}
                </button>
              </form>
            </>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        Soluciones Arquitectónicas · Grupo SACH · Guatemala · WhatsApp +502 5430 7807 · +18 años de experiencia
      </footer>

      {/* WhatsApp flotante */}
      <a href={waLink('¡Hola! Vi la página de ventanas y puertas Línea Euro y quiero una cotización 😊')}
        target="_blank" rel="noreferrer" data-testid="wa-float-btn" aria-label="WhatsApp"
        className="fixed bottom-5 right-5 z-50 bg-[#25D366] hover:scale-110 transition-transform w-14 h-14 rounded-full flex items-center justify-center shadow-2xl">
        <svg viewBox="0 0 32 32" width="30" height="30" fill="#fff"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.2 1.7 6L4 29l8.2-1.6c1.2.6 2.5.9 3.8.9 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 22c-1.2 0-2.4-.3-3.5-.8l-.6-.3-4.9 1 1-4.7-.3-.6C6.6 18.1 6 16.6 6 15 6 9.5 10.5 5 16 5s10 4.5 10 10-4.5 10-10 10zm5.5-7.5c-.3-.2-1.8-.9-2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6l-1-2.3c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.6-.4z"/></svg>
      </a>
    </div>
  );
}
